import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { getViewSingleOrMultipleInvoicesCTA } from "./shared";
export var InvoiceBasicsIA = function InvoiceBasicsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BASICS_OF_INVOICES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [INVOICES_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewSingleOrMulti;
        return (_getViewSingleOrMulti = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti === void 0 ? void 0 : _getViewSingleOrMulti.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewSingleOrMulti2, _getViewSingleOrMulti3;
        return (_getViewSingleOrMulti2 = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti2 === void 0 ? void 0 : (_getViewSingleOrMulti3 = _getViewSingleOrMulti2.getLink) === null || _getViewSingleOrMulti3 === void 0 ? void 0 : _getViewSingleOrMulti3.call(_getViewSingleOrMulti2, context.brandOrder);
      }
    }
  };
};
var BASICS_OF_INVOICES = function BASICS_OF_INVOICES(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "3A9zhg",
      defaultMessage: [{
        "type": 0,
        "value": "À propos des factures"
      }]
    });
  }
  return strictLocalize({
    id: "Xj1+xD",
    defaultMessage: [{
      "type": 0,
      "value": "Notions de base sur les factures de commande chez Faire"
    }]
  });
};
var INVOICES_EXPLANATION = function INVOICES_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "RoogvG",
    defaultMessage: [{
      "type": 0,
      "value": "Tous les commerçants sur Faire reçoivent une facture pour leur commande. Votre facture est divisée en trois sections principales : informations de facturation, informations sur les produits et informations de paiement. Pour en savoir plus sur chaque section, consultez l'article du Centre d'aide. Cliquez sur le bouton pour accéder à la page de la facture. Si vous avez besoin d'aide, contactez-nous."
    }]
  });
};